import Backbone from 'backbone';
import $ from 'jquery';

import {NucleotideType} from 'biojs/BioConstants';
import * as popup from 'Popup';

class SecondaryStructure extends Backbone.Model {
  getSvg(height: number, script?: boolean): HTMLElement {
    if (script == null) {
      script = true;
    }
    let svg = this.get('svg');
    const nucleotideType = this.get('nucleotideType');
    let svgEl = $(svg)[2];
    let middle: string;
    $(svgEl)
      .find('text')
      .each(function (_index: number, _elem: Element) {
        // @ts-expect-error shadows outer this
        const $this = $(this);
        if ($this.text() === '&') {
          middle = `${$this.attr('x')},${$this.attr('y')}`;
        }
      });
    // @ts-expect-error this is conditionally assigned above, but TS doesn't understand JQuery
    if (middle != null) {
      svg = svg.replace(
        middle,
        '" /><polyline style="stroke: black; fill: none; stroke-width: 1.5" id="outline" points="'
      );
    }
    svgEl = $(svg)[2];
    let reached = false;
    $(svgEl)
      .find('text')
      .each(function (_index: number, _elem: Element) {
        // @ts-expect-error shadows outer this
        const $this = $(this);
        if (middle != null) {
          // dimer
          if ($this.text() === '&') {
            reached = true;
            $this.remove();
          } else {
            const fill = reached ? '#1c5981' : '#86271e';
            $this.attr('fill', fill);
          }
        } else {
          $this.attr('fill', '#1c5981');
        }
        if (nucleotideType === NucleotideType.DNA && $this.text() === 'U') {
          $this.text('T');
        }
        if (nucleotideType === NucleotideType.DNA && $this.text() === 'u') {
          $this.text('t');
        }
      });
    $(svgEl).find('#seq').attr('style', '');
    $(svgEl).find('polyline').css('stroke', '#dadada');
    $(svgEl).find('#pairs').css('stroke', '#dadada');
    const curHeight = $(svgEl).attr('height');
    $(svgEl).attr('width', height).attr('height', height).css('cursor', 'pointer');
    svgEl.setAttribute('viewBox', `0 0 ${curHeight} ${curHeight}`);

    if (!script) {
      $(svgEl).find('script').remove();
      $(svgEl).find('rect').attr('onclick', '');
      $(svgEl).find('#seq').removeAttr('id');
    }
    return svgEl;
  }

  showModal(): void {
    const modalHeight = $(window).height() - 200;
    const curHeight = parseInt($(this.get('svg')).attr('height'), 10);
    const height = modalHeight < curHeight ? modalHeight : curHeight;
    const svgEl = this.getSvg(height);
    // @ts-expect-error You can, but should not pass an HTMLElement to $.html
    const modalEl = $('<div>').addClass('text-center').html(svgEl);
    const ref =
      'Secondary structure analysis performed by <a href="http://www.tbi.univie.ac.at/~ronny/RNA/index.html" target="_blank">ViennaRNA</a>.';
    modalEl.append($('<p>').html(ref).addClass('pull-right'));
    new popup.Confirm({
      title: `${this.get('name')}: ${this.get('dg')} kcal`,
      msg: modalEl[0],
      noPadding: true,
    })
      .choice('Done', 'button--tertiaryGray')
      .show();
  }
}

export default SecondaryStructure;
